import queryStringBuilder from '../../utils/queryStringBuilder';

const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getConsultants = () =>
    fetch(`${API_URL}/consultant`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getConsultant = (consultantId) =>
    fetch(`${API_URL}/consultant/${consultantId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createConsultant = (consultant) =>
    fetch(`${API_URL}/consultant`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(consultant)
    })

export const updateConsultant = (consultantId, consultant) =>
    fetch(`${API_URL}/consultant/${consultantId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(consultant)
    })

export const deleteConsultants = (consultantIds) =>
    fetch(`${API_URL}/consultant/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ consultantIds })
    })

export const getConsultantRanking = (queries) =>
    fetch(`${API_URL}/consultant/ranking?${queryStringBuilder(queries)}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getTeams = () =>
    fetch(`${API_URL}/team`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const getTeam = (teamId) =>
    fetch(`${API_URL}/team/${teamId}`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })

export const createTeam = (team) =>
    fetch(`${API_URL}/team`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(team)
    })

export const updateTeam = (teamId, team) =>
    fetch(`${API_URL}/team/${teamId}`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(team)
    })

export const deleteTeams = (teamIds) =>
    fetch(`${API_URL}/team/batch-delete`, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify({ teamIds })
    })


// WEBPACK FOOTER //
// ./src/services/api/consultant.js